import { useMemo } from "react";

function toEmbedUrl(url: string): string | null {
  try {
    const parsed = new URL(url);
    if (!parsed.hostname.endsWith("loom.com")) return url;
    const match = parsed.pathname.match(/\/share\/([a-zA-Z0-9]+)/);
    if (match) {
      return `https://www.loom.com/embed/${match[1]}`;
    }
    return url;
  } catch {
    return null;
  }
}

export function LoomEmbed({ url }: { url: string }) {
  const embedUrl = useMemo(() => toEmbedUrl(url), [url]);

  if (!embedUrl) return null;

  return (
    <div className="aspect-video w-full overflow-hidden rounded-[10px] border border-[#dfdad3] bg-[#f7f5f1]">
      <iframe
        src={embedUrl}
        title="Loom recording"
        allow="autoplay; fullscreen"
        allowFullScreen
        className="h-full w-full"
      />
    </div>
  );
}
